import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import { AppTree } from "@/App";

const el = document.getElementById("root");
const path = window.location.pathname.replace(/\/+$/, "") || "/";
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <AppTree />
    </BrowserRouter>
  </React.StrictMode>
);

// Dev builds inject editor-only attributes, so only production hydrates the pre-rendered markup.
if (el.dataset.route === path && process.env.NODE_ENV === "production") {
  hydrateRoot(el, app);
} else {
  el.innerHTML = "";
  delete el.dataset.route;
  createRoot(el).render(app);
}
document.documentElement.classList.remove("spa-shell");
el.classList.add("ready");
